import { Link } from "@heroui/react";

import YouthImpactImage from "@/assets/experiences/youth-impact.png";

export const EXPERIENCES = [
  {
    slug: "youth-impact",
    name: "Youth Impact Program",
    entity: "Youth Impact",
    tldr: {
      en: (
        <p>
          As the full-stack developer responsible for creating the app using
          Expo, I took part in Youth Impact (a <b>six-month</b>,
          experience-based sustainability mentoring program for high school and
          university students) alongside <b>13 teams</b>. Starting with a
          hackathon on <b>November 30th, 2024</b> (followed by multiple training
          days) and ending in a final presentation on <b>May 22nd, 2025</b>, our
          team of four (supported by three mentors) <b>placed 2nd</b> with our
          social project proposal.
        </p>
      ),
      de: (
        <p>
          As the full-stack developer responsible for creating the app using
          Expo, I took part in Youth Impact (a <b>six-month</b>,
          experience-based sustainability mentoring program for high school and
          university students) alongside <b>13 teams</b>. Starting with a
          hackathon on <b>November 30th, 2024</b> (followed by multiple training
          days) and ending in a final presentation on <b>May 22nd, 2025</b>, our
          team of four (supported by three mentors) <b>placed 2nd</b> with our
          social project proposal.
        </p>
      ),
      hu: (
        <p>
          As the full-stack developer responsible for creating the app using
          Expo, I took part in Youth Impact (a <b>six-month</b>,
          experience-based sustainability mentoring program for high school and
          university students) alongside <b>13 teams</b>. Starting with a
          hackathon on <b>November 30th, 2024</b> (followed by multiple training
          days) and ending in a final presentation on <b>May 22nd, 2025</b>, our
          team of four (supported by three mentors) <b>placed 2nd</b> with our
          social project proposal.
        </p>
      ),
    },
    description: {
      en: (
        <>
          <p>
            Youth Impact challenges participants to "give the answer to the
            problems of the future/present". The program pairs small teams of
            students with experienced mentors to help turn green-tech,
            recycling, social support, or similar ideas into viable,
            commercially sustainable projects. Over the course of{" "}
            <b>six months</b>, teams attend an initial hackathon, several
            workshops, and regular mentoring sessions.
          </p>
          <p>
            I was the one responsible for creating the app using{" "}
            <Link href="https://expo.dev/home" target="_blank">
              Expo
              <Link.Icon />
            </Link>{" "}
            for cross-platform compatibility and{" "}
            <Link href="https://hono.dev/" target="_blank">
              Hono
              <Link.Icon />
            </Link>{" "}
            as the backend. This has improved my skills in creating a full-stack
            application.
          </p>
          <p>
            Our group consisted of <b>4 students plus 3 mentors</b>. We competed
            against <b>12 other teams</b>, kicking things off on{" "}
            <b>November 30th, 2024</b> with a hackathon that helped us flesh out
            our idea. In the weeks that followed, we received targeted training
            (everything from market research to prototyping and impact
            measurement) and refined our project under our mentors' guidance.
          </p>
          <p>
            On <b>May 22nd, 2025</b>, the <b>remaining 8 teams</b> delivered a
            final presentation (maximum five minutes) outlining their concept,
            implementation plan, and sustainability model. We're proud to have
            earned <b>2nd place</b>.
          </p>
        </>
      ),
      de: (
        <>
          <p>
            Youth Impact fordert die Teilnehmer heraus, „die Antwort auf die
            Probleme der Zukunft/Gegenwart zu geben“. Das Programm bringt kleine
            Studententeams mit erfahrenen Mentoren zusammen, um Ideen aus den
            Bereichen Green-Tech, Recycling, soziale Unterstützung oder
            ähnlichem in lebensfähige, wirtschaftlich nachhaltige Projekte zu
            verwandeln. Im Laufe von <b>sechs Monaten</b> nehmen die Teams an
            einem initialen Hackathon, mehreren Workshops und regelmäßigen
            Mentoring-Sitzungen teil.
          </p>
          <p>
            Ich war für die Erstellung der App verantwortlich, wobei ich{" "}
            <Link href="https://expo.dev/home" target="_blank">
              Expo
              <Link.Icon />
            </Link>{" "}
            für die plattformübergreifende Kompatibilität und{" "}
            <Link href="https://hono.dev/" target="_blank">
              Hono
              <Link.Icon />
            </Link>{" "}
            als Backend verwendet habe. Dies hat meine Fähigkeiten in der
            Erstellung von Full-Stack-Anwendungen erheblich verbessert.
          </p>
          <p>
            Unsere Gruppe bestand aus <b>4 Studenten und 3 Mentoren</b>. Wir
            traten gegen <b>12 andere Teams</b> an und starteten am{" "}
            <b>30. November 2024</b> mit einem Hackathon, der uns half, unsere
            Idee auszuarbeiten. In den darauffolgenden Wochen erhielten wir
            gezielte Schulungen (von Marktforschung bis hin zu Prototyping und
            Wirkungsmessung) und verfeinerten unser Projekt unter Anleitung
            unserer Mentoren.
          </p>
          <p>
            Am <b>22. Mai 2025</b> hielten die <b>verbleibenden 8 Teams</b> eine
            Abschlusspräsentation (maximal fünf Minuten), in der sie ihr
            Konzept, ihren Implementierungsplan und ihr Nachhaltigkeitsmodell
            vorstellten. Wir sind stolz darauf, den <b>2. Platz</b> belegt zu
            haben.
          </p>
        </>
      ),
      hu: (
        <>
          <p>
            A Youth Impact arra ösztönzi a résztvevőket, hogy "adjanak választ a
            jövő és a jelen problémáira". A program kis diákcsapatokat párosít
            össze tapasztalt mentorokkal, hogy segítsenek a zöld technológiával,
            újrahasznosítással, szociális támogatással vagy hasonló területekkel
            kapcsolatos ötleteket életképes, üzletileg fenntartható projektekké
            formálni. A <b>hat hónap</b> során a csapatok részt vesznek egy
            kezdő hackathonon, számos workshopon és rendszeres mentori
            alkalmakon.
          </p>
          <p>
            Én feleltem az alkalmazás elkészítéséért, amelyhez a
            platformfüggetlenség érdekében az{" "}
            <Link href="https://expo.dev/home" target="_blank">
              Expo-t
            </Link>{" "}
            használtam, a backendhez pedig a{" "}
            <Link href="https://hono.dev/" target="_blank">
              Hono-t
            </Link>{" "}
            választottam. Ez a projekt nagyban fejlesztette a full-stack
            alkalmazások fejlesztésében szerzett készségeimet.
          </p>
          <p>
            Csoportunk <b>4 diákból és 3 mentorból</b> állt. Összesen{" "}
            <b>12 másik csapattal</b> versenyeztünk, a közös munkát pedig{" "}
            <b>2024. november 30-án</b> egy hackathonnal indítottuk, amely
            segített az ötletünk kidolgozásában. A következő hetekben célzott
            képzéseket kaptunk (a piackutatástól a prototípus-készítésen át a
            hatásmérésig), és mentoraink útmutatása mellett finomítottuk a
            projektünket.
          </p>
          <p>
            <b>2025. május 22-én</b> a <b>fennmaradó 8 csapat</b> egy (maximum
            ötperces) záróprezentáció keretében mutatta be koncepcióját,
            megvalósítási tervét és fenntarthatósági modelljét. Büszkék vagyunk
            rá, hogy megszereztük a <b>2. helyezést</b>.
          </p>
        </>
      ),
    },
    image: YouthImpactImage,
    entityUrl: "https://youthimpact.hu/",
    startDate: "2024-11-30",
    endDate: "2025-05-22",
  },
] as const;
